import React from 'react';
import { createURL } from '@sm/utils';
import { Box } from '@wds/box';

import { Button as CoreButton } from '../core/Button';
import useStyles from './useStyles';

export type Props = {
  ctaFormCopy: string;
  utSource?: string;
  utSource2?: string;
  isEnterpriseThankYou?: boolean;
};

const HeroFormCTA = ({
  ctaFormCopy = 'Sign up free',
  utSource = '',
  utSource2 = '',
  isEnterpriseThankYou,
}: Props): React.ReactElement => {
  const { enterpriseThankYouForm, button } = useStyles({ isEnterpriseThankYou });

  return (
    <Box pt={7} data-testid="HeroFormCTA" className={isEnterpriseThankYou ? enterpriseThankYouForm : undefined}>
      <CoreButton
        className={button}
        size="lg"
        href={createURL('/user/sign-up/', {
          ut_source: utSource,
          ut_source2: utSource2,
        })}
      >
        {ctaFormCopy}
      </CoreButton>
    </Box>
  );
};

export default HeroFormCTA;
